import { Helmet } from 'react-helmet-async';

export const ReferralSEO = (stats: any) => {
    const referralCode = stats?.referral_code || "join";
    const shareUrl = `https://tradeenrich.com/register?ref=${referralCode}`;

    return (
        <Helmet>
            {/* Facebook Open Graph Tags */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={shareUrl} />
            <meta property="og:title" content="Join TradeEnrich & Start Earning" />
            <meta property="og:description" content={`Join me on TradeEnrich using my code ${referralCode} and let's earn together!`} />
            <meta property="og:image" content="https://tradeenrich.com/trade-logo.jpeg" />

            {/* Twitter Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:image" content="https://tradeenrich.com/trade-logo.jpeg" />
        </Helmet>
    );
};